module.exports = __webpack_public_path__ + "static/media/slide_one.02aaaa8e.jpg";